import { gql } from "@apollo/client";

export const SUBMIT_CART = gql`
  mutation submitCart($input: SubmitCartInput!) {
    submitCart(input: $input) {
      reservation {
        id
      }
      paymentStatus {
        paymentStatus
        redirectUrl
      }
    }
  }
`;
